import React from 'react';
import LoadingIcon from './Loading';
import { useCart } from '../../../hooks/useCart';
import { CloseButton } from './CloseButton';

type MiniCartHeaderProps = {
  title: string;
  itemsTextSingular: string;
  itemsText: string;
};

export function MiniCartHeader({
  title,
  itemsTextSingular,
  itemsText,
}: MiniCartHeaderProps) {
  const { closeMinicart, items, updating } = useCart();

  return (
    <header className="minicart-header">
      <h2 className="minicart-title">{title}</h2>
      <span className="minicart-item-count">
        ({items.length} {items.length === 1 ? itemsTextSingular : itemsText})
      </span>
      <span className="minicart-loading-icon">
        {updating ? <LoadingIcon /> : ''}
      </span>
      <button aria-label="Close Cart" className="minicart-close-button" onClick={closeMinicart}>
        <CloseButton />
      </button>
    </header>
  );
}
